"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

var _reactHooks = require("@knxlab/react-hooks");

var _Text = require("../Text");

var _components = require("@knxlab/components");

var _Theme = require("../Theme");

var _utils = require("@knxlab/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var styles = _reactNative.StyleSheet.create({
  item: {
    flex: 1,
    backgroundColor: _Theme.colors.appBackground,
    justifyContent: 'center',
    alignItems: 'center'
  }
});

var _default = function _default(_ref) {
  var item = _ref.item,
      width = _ref.width,
      index = _ref.index,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$onStart = _ref.onStart,
      onStart = _ref$onStart === void 0 ? function () {} : _ref$onStart,
      _ref$onEnd = _ref.onEnd,
      onEnd = _ref$onEnd === void 0 ? function () {} : _ref$onEnd;
  var timerValue = item.timer || 10;

  var _React$useState = React.useState(timerValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      countDown = _React$useState2[0],
      setCountDown = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      started = _React$useState4[0],
      setStarted = _React$useState4[1];

  React.useEffect(function () {
    if (isActive && !started) {
      onStart();
      setStarted(true);
    }
  }, [isActive, started, index]);
  (0, _reactHooks.useInterval)(function () {
    var updatedCountDown = countDown - 1;

    if (updatedCountDown >= 0) {
      setCountDown(updatedCountDown);
    }

    if (updatedCountDown === 0) {
      setTimeout(function () {
        onEnd();
      }, 200);
      return;
    }
  }, isActive ? 1000 : null);
  var progressPercent = 100 - Math.min(100, 100 * (timerValue - (countDown - 1)) / timerValue);
  return /*#__PURE__*/React.createElement(_reactNative.View, {
    style: [styles.item]
  }, false && isActive && /*#__PURE__*/React.createElement(_components.AnimatedCircularProgress, {
    rotation: -90,
    size: 120,
    width: 15,
    fill: progressPercent,
    tintColor: "#00e0ff",
    backgroundColor: "#3d5875",
    lineCap: "round",
    arcSweepAngle: 180,
    prefill: 100,
    duration: 1000,
    easing: _reactNative.Easing.poly(1)
  }), /*#__PURE__*/React.createElement(_Text.Text, {
    color: "white",
    style: {
      fontSize: 30
    }
  }, "REPOS"), isActive && /*#__PURE__*/React.createElement(_Text.Text, {
    color: "white",
    style: {
      fontSize: 70
    }
  }, "".concat((0, _utils.renderTime)(countDown || 1, 'short'))));
};

exports["default"] = _default;